import { Link } from 'react-router-dom';
import SideBarMenu from './SideBarMenu';
import SideBarMenuItem from './SideBarMenuItem';

export interface ISideBarMenuItem {
  isActive: boolean;
  linkTo: string;
  title: string;
}

interface ISideBarProps {
  menuItems: ISideBarMenuItem[];
}

export default function SideBar({ menuItems }: Readonly<ISideBarProps>) {
  return (
    <SideBarMenu>
      {menuItems.map((menuItem, index) => (
        <SideBarMenuItem key={index} active={menuItem.isActive}>
          <Link to={menuItem.linkTo}>{menuItem.title}</Link>
        </SideBarMenuItem>
      ))}
    </SideBarMenu>
  );
}
